"use client";

import { useEffect } from "react";
import { applyTheme, getTheme, setTheme } from "../lib/theme";

export default function ThemeInit() {
  useEffect(() => {
    const theme = getTheme();
    setTheme(theme); // This will apply and save the theme
  }, []);

  return null;
}

